import { get } from 'svelte/store';
import { filterStores } from '../../state';
import { getFilterFromFilterSections } from '../getFilterFromFilterSections/getFilterFromFilterSections';

export function resetFilter() {
	const { filterStore, touchedItemsStore, filterSectionsStore } = filterStores;

	filterStore.update(() => {
		return getFilterFromFilterSections(get(filterSectionsStore));
	});

	touchedItemsStore.update(() => {
		return {};
	});
}
